import React from 'react'

import {
  ItemsPerPageLabel,
  PaginationChevronIcon,
  PaginationControls,
  PaginationFooter,
  PaginationNextButton,
  PaginationPrevButton,
  StyledPagination,
} from './ListPaginationFooter.styles'

type ListPaginationFooterProps = {
  currentPage: number
  pageSize: number
  totalRows: number
  onPageChange: (page: number) => void
}

export const ListPaginationFooter = ({
  currentPage,
  pageSize,
  totalRows,
  onPageChange,
}: ListPaginationFooterProps): JSX.Element | null => {
  if (totalRows <= 0) {
    return null
  }

  const totalPages = Math.max(1, Math.ceil(totalRows / pageSize))

  const handlePrevPage = (): void => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNextPage = (): void => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <PaginationFooter>
      <PaginationControls>
        <PaginationPrevButton
          type="button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          <PaginationChevronIcon className="bi bi-chevron-left" />
        </PaginationPrevButton>
        <StyledPagination
          activePage={currentPage}
          pages={totalPages}
          maxButtons={3}
          ellipsis
          boundaryLinks
          onSelect={eventKey => onPageChange(Number(eventKey))}
          size="sm"
          total={totalRows}
        />
        <PaginationNextButton
          type="button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          <PaginationChevronIcon className="bi bi-chevron-right" />
        </PaginationNextButton>
      </PaginationControls>
      <ItemsPerPageLabel>
        {pageSize} itens por página
      </ItemsPerPageLabel>
    </PaginationFooter>
  )
}
